import httpClient from './httpClient'

export default {
  async getAssistants() {
    try {
      const ret = await httpClient.get('/assist-ai/assistants')
      return ret
    } catch (error) {
      return error
    }
  },
  async getAssistantById(assistantId) {
    try {
      const ret = await httpClient.get(
        `/assist-ai/assistant_by_id/${assistantId}`
      )
      return ret
    } catch (error) {
      return error
    }
  },
  async purchaseOverview({ videoIds, lang }) {
    try {
      const ret = await httpClient.post('/assist-ai/purchase_overview', {
        video_ids: videoIds,
        lang,
      })
      return ret
    } catch (error) {
      return error
    }
  },
  async buyAndCreate({
    videoIds,
    lang,
    name,
    openNewTab,
    initialQuestion,
    question_suggestions,
  }) {
    try {
      const ret = await httpClient.post('/assist-ai/buy_and_create', {
        video_ids: videoIds,
        lang,
        name,
        open_new_tab: openNewTab,
        initial_question: initialQuestion,
        question_suggestions,
      })
      return ret
    } catch (error) {
      return error
    }
  },
  async addVideos({ assistantId, videoIds }) {
    try {
      const ret = await httpClient.post('/assist_ai/update_assistant_videos', {
        video_ids: videoIds,
        assistant_id: assistantId,
      })
      return ret
    } catch (error) {
      return error
    }
  },
  async updateAssistantInfo(
    assistantId,
    { name, openNewTab, initialQuestion, prompt, status, question_suggestions }
  ) {
    try {
      const ret = await httpClient.put(
        `/assist-ai/update_assistant_info/${assistantId}`,
        {
          name,
          open_new_tab: openNewTab,
          initial_question: initialQuestion,
          prompt,
          status,
          question_suggestions,
        }
      )
      return ret
    } catch (error) {
      return error
    }
  },
  async updateAssistantVideoBind(assistantId, { videoIds, lang }) {
    try {
      const ret = await httpClient.put(
        `/assist-ai/update_assistant_video_bind/${assistantId}`,
        {
          video_ids: videoIds,
          lang,
        }
      )
      return ret
    } catch (error) {
      return error
    }
  },
  async updateChatVisibility({ assistant_id, video_id, chat_is_visible }) {
    try {
      const ret = await httpClient.post('assist-ai/update_chat_visibility', {
        assistant_id,
        video_id,
        chat_is_visible,
      })
      return ret
    } catch (error) {
      return error
    }
  },
  async deleteAssistant(assistantId) {
    try {
      const ret = await httpClient.post(
        `/assist-ai/delete_assistant/${assistantId}`
      )
      return ret
    } catch (error) {
      return error
    }
  },
}
